import React from 'react'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import {
    formataTableCellHeadExibeDadosTitulo,
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValor,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
} from '../../../business-components/Formata/Formata'

import {
    DivFormEstudo,
} from '../../../business-components/Div/Div'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    SvgIconReceitaMensal,
} from '../../../business-components/SvgIcon/SvgIconGarantiasAtuais/SvgIconGarantiasAtuais'

import {
    dadosCompletosCliente,
    dadosCompletosConjuge,
} from '../cliente-form/ClienteService'

import {
    tituloEstudoGarantiaCliente,
    tituloEstudoGarantiaConjuge,
    relatorioModoApresentacao,
} from './EstudoService'

import {
    CardGridEstudoTabelaPadrao,
} from './EstudoComp'



const EstudoFormGarantiasReceitaMensal = ( { values, estudo, report, jsonConfiguracao, indInicial, indFinal } ) => {

    const GarantiasReceitaMensal = () => {

        let headList = [
            {
                colSpan: 8,
                headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.tipoReceitaMensal, report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.valorMensalAtualQuebraEspecial, report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valorEstimado, report),
            },
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.anoFinal, report),
            },
        ]
        
        if (dadosCompletosCliente(values)) {
            headList.push(
                {
                    colSpan: 3,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                                tituloEstudoGarantiaCliente(values), report
                            ),
                },
            )
        }

        if (dadosCompletosConjuge(values)) {
            headList.push(
                {
                    colSpan: 3,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                                tituloEstudoGarantiaConjuge(values), report
                            ),
                },
            )
        }

        return (
            <TableExibeDados
                report={report}
            >
                <TableHeadExibeDados
                    report={report}
                >
                    <TableRowHeadExibeDados
                        dados={headList}
                    />
                </TableHeadExibeDados>

                <TableBodyExibeDados>
                    {estudo.current.receitaMensal?.map((item, ind) => {

                        let colSpan = 0

                        return (!indFinal || (ind >= indInicial && ind <= indFinal)) && (
                            <TableRowBodyExibeDados
                                key={ind}
                                report={report}
                            >
                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                    primeiraColuna={true}
                                >
                                    {item.descricao}
                                </TableCellBodyExibeDados>
                                
                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.valorMensal}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.valorEstimado}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.anoFinal}
                                </TableCellBodyExibeDados>
                                
                                {dadosCompletosCliente(values) && (
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {item.valorGarantiaCliente}
                                    </TableCellBodyExibeDados>
                                )}
                                
                                {dadosCompletosConjuge(values) && (
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {item.valorGarantiaConjuge}
                                    </TableCellBodyExibeDados>
                                )}
                            </TableRowBodyExibeDados>
                        )
                    })}
                </TableBodyExibeDados>
            </TableExibeDados>  
        )
    }

    return (
        <DivFormEstudo>
            {report || relatorioModoApresentacao(values)
                ?
                    //<div
                    //    className={(relatorioModoApresentacao(values) ? 'mt-10 ml-5 mr-5' : '')} // mudança da fonte: acrescentou mt-10
                    //>
                    <>
                        <div
                            className={CLASSNAME().formataReportDetalhamento}
                            align='left'
                        >
                            {jsonConfiguracao && jsonConfiguracao.estudoReportDetalhamentoReceitaMensalTextoCabecalho
                                ?
                                    <>
                                        {jsonConfiguracao.estudoReportDetalhamentoReceitaMensalTextoCabecalho}
                                        <br/>
                                        <br/>
                                        <br/>
                                    </>
                                :
                                    MESSAGE().estudoReportDetalhamentoReceitaMensalTextoCabecalho
                            }
                        </div>

                        <GarantiasReceitaMensal />
                    </>
                    //</div>
                :
                    <CardGridEstudoTabelaPadrao
                        values={values}
                        SvgIcon={SvgIconReceitaMensal}
                        label={LABEL.receitaMensal}
                        helpTextMorte={HELPTEXT.estudoReceitaMensal}
                        helpTextInvalidez={HELPTEXT.estudoReceitaMensal}
                        component={<GarantiasReceitaMensal/>}
                        popup={true}
                    />
            }
        </DivFormEstudo>
    )
}

export default EstudoFormGarantiasReceitaMensal